var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderbyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 70,
    viewBox: "0 0 106 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.99976,
    width: 50,
    height: 12,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 29.9998,
    width: 60,
    height: 12,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 57.9998,
    width: 99,
    height: 12,
    rx: 6,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1742 26.0894C66.6086 24.6977 66.6086 22.441 68.1742 21.0493L83.6654 1.04377C85.2311 -0.347921 87.7689 -0.347921 89.3346 1.04377L104.826 21.0493C106.391 22.441 106.391 24.6977 104.826 26.0894C103.26 27.4811 100.721 27.4811 99.1557 26.0894L90.5091 14.8399L90.5091 45.4363C90.5091 47.4045 88.7142 49 86.5 49C84.2858 49 82.4909 47.4045 82.4909 45.4363L82.4909 14.8399L73.8443 26.0894C72.2787 27.4811 69.7399 27.4811 68.1742 26.0894Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderbyIcon);
export default __webpack_public_path__ + "static/media/orderby-icon.830035e1.svg";
export { ForwardRef as ReactComponent };